import { TRANSITION_SLOW_MS } from "@frontend/styles/constants";

export const SELECT_TAG_NAME = "select" as const;

export const SELECT_ITEM_TAG_NAME = "select-item" as const;

export const SELECT_GROUP_TAG_NAME = "select-group" as const;

export const SELECT_VARIANTS = ["default", "ghost"] as const;

export const SELECT_LAYOUTS = ["default", "text"] as const;

export const SELECT_EFFECTS = ["press", "pulse", "check", "none"] as const;

export const SELECT_ACK_ATTRIBUTE = "data-select-ack" as const;

export const SELECT_EFFECT_ATTRIBUTE = "data-select-effect" as const;

export const SELECT_LEFT_INSET_VAR = "--select-left-inset" as const;

export const SELECT_PULSE_DURATION_MS = TRANSITION_SLOW_MS;

export const SELECT_CHECK_DURATION_MS = TRANSITION_SLOW_MS;
